import { ApiClient } from './ApiClient';

export interface JobListing {
    applicationClosingDate: string; // ISO 8601 string (convert to Date if needed)
    category: string;
    title: string;
    position: string;
    country: string;
    region: string;
    location: string;
    jobPageURL: string; // stringified URL from backend
    experienceLevel: string;
    latitude: number;
    longitude: number;
    zoomLevel: number;
}

export interface ValueCount {
    value: string;
    count: number;
}

export interface JobListingsPageData {
    jobListings: JobListing[];
    totalPages: number;
    totalJobListings: number;
    relevantLocations: ValueCount[];
    relevantCategories: ValueCount[];
    relevantPositions: ValueCount[];
    relevantExperience: ValueCount[];
}

export interface JobListingsQueryParams {
    lang?: string;
    Categories?: string;
    Locations?: string;
    Positions?: string;
    Countries?: string;
    Regions?: string;
    Experience?: string;
    radius?: number;
    page?: number; // default is 1
    q?: string;
}

export class JobListingsApi {
    private apiClient: ApiClient;

    constructor() {
        this.apiClient = new ApiClient('/api/joblistings');
    }

    public getJobListings(params: JobListingsQueryParams = {}): Promise<JobListingsPageData> {
        return this.apiClient.get<JobListingsPageData>('pageData', params);
    }
}

// Export a single shared instance
export const jobListingsApi = new JobListingsApi();